import { useState, useEffect, useCallback } from "react";
import "./index.css";

type IPState =
  | { status: "loading" }
  | { status: "success"; ip: string }
  | { status: "error" };

export function App() {
  const [state, setState] = useState<IPState>({ status: "loading" });
  const [copied, setCopied] = useState(false);

  const fetchIP = useCallback(async () => {
    setState({ status: "loading" });
    try {
      const res = await fetch("/api/ip");
      const data = await res.json();
      setState({ status: "success", ip: data.ip });
    } catch {
      setState({ status: "error" });
    }
  }, []);

  useEffect(() => {
    fetchIP();
  }, [fetchIP]);

  const copyIP = async () => {
    if (state.status !== "success") return;
    try {
      await navigator.clipboard.writeText(state.ip);
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    } catch {
      setCopied(false);
    }
  };

  return (
    <main className="app-shell">
      {state.status === "loading" && <p className="ip-text">Loading...</p>}

      {state.status === "error" && <p className="ip-text">Unable to get IP</p>}

      {state.status === "success" && (
        <section className="ip-stack">
          <button className="ip-button" type="button" onClick={copyIP}>
            {state.ip}
          </button>
          <button className="copy-button" type="button" onClick={copyIP}>
            {copied ? "Copied" : "Copy"}
          </button>
        </section>
      )}
    </main>
  );
}

export default App;
